import { FC, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { useThemeContext } from '@/contexts/ThemeContext'
import { getPillBadgeClassNames } from './PillBadge.utils'

export type PillBadgeVariant =
  | 'neutral'
  | 'outlined'
  | 'transparent'
  | 'brand'
  | 'blue'
  | 'primary'
  | 'warm-01'
  | 'warning'
  | 'error-500'
export type PillBadgeSize = 'sm' | 'md'

interface Props extends PropsWithChildren {
  variant: PillBadgeVariant
  size?: PillBadgeSize
  className?: string
}

export const PillBadge: FC<Props> = ({ variant, size = 'md', className, children }) => {
  const { isDarkMode } = useThemeContext()

  return (
    <div className={classNames('pill-badge', className, getPillBadgeClassNames(variant, size, isDarkMode))}>
      {children}
    </div>
  )
}
